<template>
  <div>
    <NavBar />
    <Edit
      :item="currentContato"
      :editorFunction="editorFunction"
      :close="closeEditor"
      :onSuccess="onEditSuccess"
    />
    <div class="container">
      <SideBar />
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <div class="message" v-if="error">Erro: {{ error.message }}</div>
          <h1 class="title">
            <svg viewBox="0 -26 512 512" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m256 100c-5.519531 0-10 4.480469-10 10s4.480469 10 10 10 10-4.480469 10-10-4.480469-10-10-10zm0 0"
              ></path>
              <path
                d="m90 280c5.519531 0 10-4.480469 10-10s-4.480469-10-10-10-10 4.480469-10 10 4.480469 10 10 10zm0 0"
              ></path>
              <path
                d="m336 0c-90.027344 0-163.917969 62.070312-169.632812 140.253906-85.738282 4.300782-166.367188 66.125-166.367188 149.746094 0 34.945312 13.828125 68.804688 39 95.632812 4.980469 20.53125-1.066406 42.292969-16.070312 57.296876-2.859376 2.859374-3.714844 7.160156-2.167969 10.898437 1.546875 3.734375 5.191406 6.171875 9.238281 6.171875 28.519531 0 56.003906-11.183594 76.425781-30.890625 19.894531 6.78125 45.851563 10.890625 69.574219 10.890625 90.015625 0 163.898438-62.054688 169.628906-140.222656 20.9375-.929688 42.714844-4.796875 59.945313-10.667969 20.421875 19.707031 47.90625 30.890625 76.425781 30.890625 4.046875 0 7.691406-2.4375 9.238281-6.171875 1.546875-3.738281.691407-8.039063-2.167969-10.898437-15.003906-15.003907-21.050781-36.765626-16.070312-57.296876 25.171875-26.828124 39-60.6875 39-95.632812 0-86.886719-86.839844-150-176-150zm-160 420c-23.601562 0-50.496094-4.632812-68.511719-11.800781-3.859375-1.539063-8.269531-.527344-11.078125 2.539062-12.074218 13.199219-27.773437 22.402344-44.878906 26.632813 9.425781-18.058594 11.832031-39.347656 6.097656-59.519532-.453125-1.589843-1.292968-3.042968-2.445312-4.226562-22.6875-23.367188-35.183594-53.066406-35.183594-83.625 0-70.46875 71.4375-130 156-130 79.851562 0 150 55.527344 150 130 0 71.683594-67.289062 130-150 130zm280.816406-186.375c-1.152344 1.1875-1.992187 2.640625-2.445312 4.226562-5.734375 20.171876-3.328125 41.460938 6.097656 59.519532-17.105469-4.226563-32.804688-13.433594-44.878906-26.632813-2.808594-3.0625-7.21875-4.078125-11.078125-2.539062-15.613281 6.210937-37.886719 10.511719-58.914063 11.550781-2.921875-37.816406-21.785156-73.359375-54.035156-99.75h130.4375c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-161.160156c-22.699219-11.554688-48.1875-18.292969-74.421875-19.707031 5.746093-67.164063 70.640625-120.292969 149.582031-120.292969 84.5625 0 156 59.53125 156 130 0 30.558594-12.496094 60.257812-35.183594 83.625zm0 0"
              ></path>
              <path
                d="m256 260h-126c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h126c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
              ></path>
              <path
                d="m256 320h-166c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h166c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
              ></path>
              <path
                d="m422 100h-126c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h126c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
              ></path>
            </svg>
            Contatos Externos
          </h1>

          <ul class="tabs"></ul>
          <div class="card">
            <div class="card-body">
              <table class="table">
                <thead>
                  <tr>
                    <th>Imagem</th>
                    <th>Descrição</th>
                    <th>Link</th>
                    <th>Ordem</th>
                    <th>
                      <button
                        class="button button-success button-sm button-block"
                        v-on:click="openEditor()"
                      >
                        <svg
                          style="width: 12px; height: 12px; fill: #fff"
                          x="0px"
                          y="0px"
                          viewBox="0 0 42 42"
                        >
                          <path
                            d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
                          ></path>
                        </svg>
                        Adicionar
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(i, index) in contatosExternos" v-bind:key="index">
                    <td>
                      <div class="imgbox" v-if="i.img !== ''">
                        <span>
                          <button
                            class="button button-error button-sm"
                            v-on:click="deleteImg(index)"
                          >
                            <svg
                              style="
                                margin-top: 4px;
                                width: 12px;
                                height: 12px;
                                fill: #fff;
                              "
                              x="0px"
                              y="0px"
                              viewBox="0 0 459 459"
                            >
                              <g>
                                <path
                                  d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                                ></path>
                              </g>
                            </svg>
                          </button>
                          <img :src="getImage(i.img)" />
                        </span>
                      </div>
                      <div class="imgbox" v-else>
                        <span>
                          <label class="button button-sm button-success">
                            <svg
                              style="
                                float: left;
                                width: 18px;
                                height: 18px;
                                fill: #fff;
                              "
                              x="0px"
                              y="0px"
                              viewBox="0 0 612 612"
                            >
                              <g>
                                <path
                                  d="M494.7,255C476.85,168.3,400.35,102,306,102c-73.95,0-137.7,40.8-168.3,102C58.65,214.2,0,277.95,0,357 c0,84.15,68.85,153,153,153h331.5c71.4,0,127.5-56.1,127.5-127.5C612,316.2,558.45,260.1,494.7,255z M357,331.5v102H255v-102 h-76.5L306,204l127.5,127.5H357z"
                                ></path>
                              </g>
                            </svg>
                            <input
                              type="file"
                              name="img"
                              style="display: none"
                              accept="image/jpg, image/jpeg, image/png, image/webp"
                              @change="uploadImage(index)"
                            />
                          </label>
                        </span>
                      </div>
                    </td>
                    <td>{{ i.descricao }}</td>
                    <td>{{ i.link }}</td>
                    <td>
                      <span class="label primary">{{ i.ordem }}</span>
                    </td>

                    <td class="actions">
                      <a
                        class="button button-primary"
                        v-on:click="openEditor(index)"
                      >
                        <svg
                          x="0px"
                          y="0px"
                          style="
                            margin-top: 4px;
                            width: 12px;
                            height: 12px;
                            fill: #fff;
                          "
                          viewBox="0 0 485.219 485.22"
                        >
                          <g>
                            <path
                              d="M467.476,146.438l-21.445,21.455L317.35,39.23l21.445-21.457c23.689-23.692,62.104-23.692,85.795,0l42.886,42.897 C491.133,84.349,491.133,122.748,467.476,146.438z M167.233,403.748c-5.922,5.922-5.922,15.513,0,21.436 c5.925,5.955,15.521,5.955,21.443,0L424.59,189.335l-21.469-21.457L167.233,403.748z M60,296.54c-5.925,5.927-5.925,15.514,0,21.44 c5.922,5.923,15.518,5.923,21.443,0L317.35,82.113L295.914,60.67L60,296.54z M338.767,103.54L102.881,339.421 c-11.845,11.822-11.815,31.041,0,42.886c11.85,11.846,31.038,11.901,42.914-0.032l235.886-235.837L338.767,103.54z M145.734,446.572c-7.253-7.262-10.749-16.465-12.05-25.948c-3.083,0.476-6.188,0.919-9.36,0.919 c-16.202,0-31.419-6.333-42.881-17.795c-11.462-11.491-17.77-26.687-17.77-42.887c0-2.954,0.443-5.833,0.859-8.703 c-9.803-1.335-18.864-5.629-25.972-12.737c-0.682-0.677-0.917-1.596-1.538-2.338L0,485.216l147.748-36.986 C147.097,447.637,146.36,447.193,145.734,446.572z"
                            ></path>
                          </g>
                        </svg>
                      </a>
                      &nbsp;
                      <button
                        class="button button-error"
                        v-on:click="deleteContatoExterno(index)"
                      >
                        <svg
                          style="
                            margin-top: 4px;
                            width: 12px;
                            height: 12px;
                            fill: #fff;
                          "
                          x="0px"
                          y="0px"
                          viewBox="0 0 459 459"
                        >
                          <g>
                            <path
                              d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                            ></path>
                          </g>
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Edit from "./Edit";
import { get, post, put, del, uploadImage } from "@/helpers/apiRequest";
import { getImage } from "@/helpers/utils";
const url = "/contatosexternos";

const CONTATO_EXTERNO_MODEL = {
  descricao: "",
  link: "",
  ordem: "",
  abrirJanela: false,
  img: "",
};

export default {
  components: {
    Edit,
  },
  name: "contatosExternos",
  data() {
    return {
      loading: false,
      error: null,
      editorFunction: () => {},
      contatosExternos: [],
      currentContato: { ...CONTATO_EXTERNO_MODEL },
    };
  },
  methods: {
    getImage: getImage,
    openEditor(index = -1) {
      if (index < 0) {
        this.currentContato = { ...CONTATO_EXTERNO_MODEL };
        this.editorFunction = this.postContatoExterno();
      } else {
        this.currentContato = { ...this.contatosExternos[index] };
        this.editorFunction = this.updateContatoExterno();
      }

      this.$modal.show("editContatoExterno");
    },
    closeEditor() {
      this.currentContato = { ...CONTATO_EXTERNO_MODEL };
      this.$modal.hide("editContatoExterno");
    },

    onEditSuccess() {
      this.$modal.hide("editContatoExterno");
      this.fetchContatosExternos();
    },

    edit(apiMethod, onSuccess, onError, onFinish) {
      this.loading = true;
      return apiMethod()
        .then((json) => {
          this.error = null;
          if (onSuccess && typeof onSuccess === "function") {
            onSuccess();
          }
        })
        .catch((err) => {
          this.error = err;
          if (onError && typeof onError === "function") {
            onError();
          }
        })
        .finally(() => {
          this.loading = false;
          if (onFinish && typeof onFinish === "function") {
            onFinish();
          }
        });
    },

    updateContatoExterno(callback) {
      const apiMethod = put.bind(
        this,
        `${url}/${this.currentContato._id}`,
        this.currentContato
      );
      return this.edit.bind(this, apiMethod);
    },

    postContatoExterno(callback) {
      const apiMethod = post.bind(this, url, this.currentContato);
      return this.edit.bind(this, apiMethod);
    },

    deleteContatoExterno(index, callback) {
      this.$swal({
        title: "Confirma remover?",
        showCancelButton: true,
        type: "error",
        confirmButtonColor: "#d82727",
      }).then(() => {
        const { _id } = this.contatosExternos[index];
        const apiMethod = del.bind(this, `${url}/${_id}`);
        this.edit(apiMethod, this.onEditSuccess);
      });
    },

    fetchContatosExternos(callback) {
      this.loading = true;
      get(url)
        .then((json) => {
          this.contatosExternos = json;
          this.error = null;
        })
        .catch((err) => {
          this.error = err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    uploadImage(index) {
      event.preventDefault();
      const { _id } = this.contatosExternos[index];
      const settings = {
        el: event.target,
        str: `/contatosexternos/img/${_id}?single=true`,
        dim: "255x255",
      };
      this.loading = true;
      const apiMethod = uploadImage.bind(this, settings);
      this.edit(apiMethod, this.onEditSuccess);
    },

    deleteImg(index) {
      this.$swal({
        title: "Confirma remover?",
        showCancelButton: true,
        type: "error",
        confirmButtonColor: "#d82727",
      }).then(() => {
        const { _id } = this.contatosExternos[index];
        const apiMethod = del.bind(
          this,
          `/upload/contatosexternos/img/${_id}/no-index/?single=true`
        );
        this.edit(apiMethod, this.onEditSuccess);
      });
    },
  },

  beforeMount() {
    this.fetchContatosExternos();
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ContatosExternos/ContatosExternos.vue